import {BaseApiService} from "../../../infrastructure/domain-services/base-api-service";
import {BaseUtilsService} from "../../../infrastructure/domain-services/base-utils-service";
import {SearchFactory} from "./search-factory";

export class SearchApi extends BaseApiService {
  static injectables = [...BaseUtilsService.injectables, SearchFactory];
}
